export default __webpack_public_path__ + "static/strategy-f49c13c4fbc9c471313fec84eee7958a.png";